module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/368.98ecdb16.png";